(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
      entries.forEach(function (e) {
        var desc = e.target.closest('[data-zk-desc]');
        if (desc) update(desc);
        if (e.target.classList.contains('zk-pcard__specs')) fitChips(e.target);
      });
    }) : null;

    function update(row) {
      if (!row) return;
      var s = row.querySelector('.zk-pcard__desc-scroll');
      if (!s) return;
      var max = s.scrollHeight - s.clientHeight;
      row.classList.toggle('can-up', s.scrollTop > 1);
      row.classList.toggle('can-down', max - s.scrollTop > 1);
    }
    function init(root) {
      (root || document).querySelectorAll('[data-zk-desc]:not([data-zk-desc-ready])').forEach(function (row) {
        row.setAttribute('data-zk-desc-ready', '');
        var s = row.querySelector('.zk-pcard__desc-scroll');
        if (!s) return;
        s.addEventListener('scroll', function () { update(row); }, { passive: true });
        if (ro) {
          ro.observe(s);
          var p = s.querySelector('.zk-pcard__desc');
          if (p) ro.observe(p);
        }
        update(row);
      });
      (root || document).querySelectorAll('.zk-pcard__specs:not([data-zk-chips-ready])').forEach(function (row) {
        row.setAttribute('data-zk-chips-ready', '');
        if (ro) ro.observe(row);
        fitChips(row);
      });
    }
    function fitChips(row) {
      var track = row.querySelector('.zk-pcard__chip-track');
      var run = track && track.querySelector('.zk-pcard__chip-run:not(.is-clone)');
      if (!run) return;
      var clone = track.querySelector('.zk-pcard__chip-run.is-clone');
      if (clone) clone.remove();
      row.classList.remove('is-marquee');
      row.classList.remove('can-scroll');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var pad = parseFloat(getComputedStyle(row).paddingLeft) + parseFloat(getComputedStyle(row).paddingRight);
      var overflow = run.scrollWidth > row.clientWidth - pad + 1;
      if (!overflow) return;
      if (reduce) {
        row.classList.add('can-scroll');
        return;
      }
      var copy = run.cloneNode(true);
      copy.classList.add('is-clone');
      copy.setAttribute('aria-hidden', 'true');
      track.appendChild(copy);
      var shift = run.offsetWidth + 4;
      var seconds = Math.max(8, shift / 28);
      row.style.setProperty('--zk-chip-shift', shift + 'px');
      row.style.setProperty('--zk-chip-dur', seconds + 's');
      row.classList.add('is-marquee');
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-zk-desc-step]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var s = btn.closest('[data-zk-desc]').querySelector('.zk-pcard__desc-scroll');
      s.scrollBy({ top: Number(btn.dataset.zkDescStep) * s.clientHeight * 0.7, behavior: 'smooth' });
    });

    init();
    new MutationObserver(function () { init(); }).observe(document.body, { childList: true, subtree: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        document.querySelectorAll('[data-zk-desc]').forEach(update);
        document.querySelectorAll('.zk-pcard__specs').forEach(fitChips);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
